var render, staticRenderFns
import script from "./SchoolTitle2.vue?vue&type=script&lang=js&"
export * from "./SchoolTitle2.vue?vue&type=script&lang=js&"
import style0 from "./SchoolTitle2.vue?vue&type=style&index=0&id=bab9484e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports